import { useSyncExternalStore } from 'react';
import { POINTER_TIER_MIN_WIDTH } from '@/config/scale';

// A min-width query on purpose: the media mock of the test setup answers `matches: true`
// for every query, and that must mean the pointer tier.
const POINTER_TIER_QUERY = `(min-width: ${String(POINTER_TIER_MIN_WIDTH)}px)`;

const subscribe = (onChange: () => void): (() => void) => {
  const query = window.matchMedia(POINTER_TIER_QUERY);
  query.addEventListener('change', onChange);
  return () => {
    query.removeEventListener('change', onChange);
  };
};

const getIsTouchTier = (): boolean => !window.matchMedia(POINTER_TIER_QUERY).matches;

/** True below 1200px: the sidebar is a drawer and controls use the touch sizes. */
export const useIsTouchTier = (): boolean => useSyncExternalStore(subscribe, getIsTouchTier);
